__webpack_require__.p = "https://int.static.uploader-widget.video.wds.io/";